import popup from './module/popup.js';
import products from './module/products.js';
import Storage from './module/storage.js';
import uploadHandler from './module/uploadHandler.js';
import productPage from './module/productPage.js';
import events from './module/event.js';
import MindstoreHooks from './module/mindstoreHooks.js';
import Logger from './module/logger.js';
import PhotoWatchdog from './module/photoWatchdog.js';

// loop and wait for 5 seconds for hj to be defined and then trigger event once it is defined
document.addEventListener("DOMContentLoaded", function () {
    var checkHj = setInterval(function () {
        if (typeof hj === 'function') {
            hj('event', 'Page Loaded - MSCP 6.0.48');
            console.debug('Page Loaded - MSCP 6.0.48');
            clearInterval(checkHj);
            clearTimeout(hjTimeout);
        }
    }, 100);
    var hjTimeout = setTimeout(function () {
        clearInterval(checkHj);
        console.error('MSCP 6.0.48 - Hotjar not defined after 5 seconds, giving up on sending page loaded event');
    }, 5000);
});

// Check if version from server is different than current version and if so, force load new version of script and css
document.addEventListener("DOMContentLoaded", function () {
    if (window?.mscp?.version) {
        const serverVersion = window.mscp.version;
        const currentVersion = '6.0.48';
        if (serverVersion !== currentVersion) {
            console.error(`MSCP version mismatch: Server version is ${serverVersion} but current version is ${currentVersion}. Reloading js and script files.`);
            // Reload all css and js files with new version query parameter to force browser to load new version
            // const links = document.querySelectorAll('link[rel="stylesheet"]');
            // links.forEach(link => {
            //     const href = link.getAttribute('href');
            //     if (href && href.includes('mindstore-customizable-product')) {
            //         const newHref = href.replace(/v=\d+\.\d+\.\d+/, `v=${serverVersion}`);
            //         link.setAttribute('href', newHref);
            //     }
            // });
            // const scripts = document.querySelectorAll('script');
            // scripts.forEach(script => {
            //     const src = script.getAttribute('src');
            //     if (src && src.includes('mindstore-customizable-product')) {
            //         const newSrc = src.replace(/v=\d+\.\d+\.\d+/, `v=${serverVersion}`);
            //         script.setAttribute('src', newSrc);
            //     }
            // });
        }
    }
});

class MSCP {

    constructor() {
        this.init();
    }

    async init() {
        this.preload(); // Preload necessary data
        PhotoWatchdog.start(); // Silent telemetry for the rare iOS photo-blank incident
        uploadHandler.startQueue(); // Start the upload queue if there are pending uploads
        this.setupButtonActions();
        this.addEventListeners();
        this.ifAutoOpen(); // Check if the popup should be opened automatically
        this.checkForPopupLink(); // Check for links that should open the popup
    }

    addEventListeners() {
        events.add('openPopup', async (options) => {
            popup.load(options);
            window.Mindstore.DataLayer?.clickEvent('mscp_open_popup');
        });
        // events.add('openEditPopup', async (options) => {
        //     if (!options) {
        //         options = {};
        //     }
        //     options.openInEdit = true;

        //     // Clone the current session to create an independent copy
        //     // This ensures that editing doesn't affect the product already in cart
        //     const currentSessionId = Storage.getCurrentSessionId();
        //     if (currentSessionId) {
        //         Logger.log('Cloning session before edit to create independent copy');
        //         await Storage.cloneSession(currentSessionId, true, null);
        //     }

        //     popup.load(options);
        //     window.Mindstore.DataLayer?.clickEvent('mscp_open_edit_popup');
        // });
    }

    checkForPopupLink() {
        document.querySelectorAll('a').forEach((link) => {
            const url = new URL(link.href, window.location.origin);
            if (url.searchParams.has('popup')) {
                const options = {};
                if (url.searchParams.has('info')) {
                    const info = url.searchParams.get('info');
                    if (info) {
                        options.info = info;
                    }
                }
                link.addEventListener('click', async (e) => {
                    e.preventDefault();
                    await events.trigger('openPopup', options);
                });
            }
        });
    }

    async ifAutoOpen() {
        // Automatically open the popup if argument ?popup=1 is present in the URL
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('popup')) {
            const options = {};
            if (urlParams.has('info')) {
                const info = urlParams.get('info');
                if (info) {
                    options.info = info;
                }
            }
            // replace the URL to avoid reopening without ?popup to avoid open popup again on reload
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.delete('popup');
            window.history.replaceState({}, document.title, newUrl.toString());
            await events.trigger('openPopup', options); // Trigger the popup to open
        }
    }

    async preload() {
        // Storage.setDefaults();
        Storage.updateVersion();
        products.getProducts();
    }

    setupButtonActions() {
        Array.from(document.getElementsByClassName('mscp-start-button')).forEach((button) => {
            button.disabled = false;
            button.addEventListener('click', async (e) => {
                e.preventDefault();
                events.trigger('openPopup');
            });
        });
    }
}

window.addEventListener('load', function () {
    new MSCP();
});

